import React from 'react';
import { useTranslation } from 'react-i18next';
import Form, { FormTemplate } from '../../../../molecules/Form/Form';
import { FormContainerModifier } from '../../../../molecules/Form';
import Btn, { BtnModifier } from '../../../../molecules/Btn';
import { Namespace } from '../../../../../translation/namespace';
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import IForm from '../../../../../types/IForm';
import { SVGIcon } from '../../../../atoms/SVG';
import { ContentWrapperAction as Action } from '../../../../blocks/ContentWrapper/ContentWrapper.types';

type MoveContentBlockFormProps = {
  actionKey: keyof typeof Action;
  actionKeyToIcon: SVGIcon;
  beforeSubmit: () => void;
  blockIndex: number;
  elementType: string;
  form: IForm;
  isActionDisabled: boolean;
  onFailure: () => void;
  onSuccess: () => void;
};

export function MoveContentBlockForm({
  actionKey,
  actionKeyToIcon,
  beforeSubmit,
  blockIndex,
  elementType,
  form,
  isActionDisabled,
  onFailure,
  onSuccess,
}: MoveContentBlockFormProps) {
  const { t } = useTranslation(Namespace.ContentWrapper);

  const position = actionKey === Action.moveBlockUp ? blockIndex : blockIndex + 2;
  return (
    <Form
      id={`content-wrapper-${actionKey}-form`}
      model={form}
      containerModifier={[FormContainerModifier.NO_PADDING]}
      beforeSubmit={beforeSubmit}
      onSuccess={onSuccess}
      onFailure={onFailure}
      allowNavigationOnUnsavedChanges
      submittableWithoutChange
    >
      <FormTemplate>
        {model => (
          <>
            {model.hiddenFields}
            <Btn
              type="submit"
              text={
                isActionDisabled
                  ? t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.disabled`)
                  : t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.text`, {
                      position,
                    })
              }
              titleText={
                isActionDisabled
                  ? t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.disabled`)
                  : t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.text`, {
                      position,
                    })
              }
              hiddenText
              modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
              svgSpriteId={actionKeyToIcon}
              ariaDisabled={isActionDisabled}
              routing={false}
              tooltipPlacement={TooltipPlacement.TOP}
            />
          </>
        )}
      </FormTemplate>
    </Form>
  );
}
